import { render, staticRenderFns } from "./searchHead.vue?vue&type=template&id=4233be82&scoped=true"
import script from "./searchHead.vue?vue&type=script&lang=js"
export * from "./searchHead.vue?vue&type=script&lang=js"
import style0 from "./searchHead.vue?vue&type=style&index=0&id=4233be82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233be82",
  null
  
)

export default component.exports